import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const Profile = () => {
    const [userData, setUserData] = useState({})
    const [userRoutines, setUserRoutines] = useState({})

   

    useEffect(() => {
        const token = localStorage.getItem("token")
        const fetchUserData = async () => {
            try {
                const response = await fetch("https://fitnesstrac-kr.herokuapp.com/api/users/me", {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    }
                })
                const result = await response.json()
                console.log(result)
                setUserData(result)
                console.log(userData)
                localStorage.setItem("username", result.username)
            } catch (err) {
                console.error(err)
            }
        }
        fetchUserData()
 
        const fetchUserRoutines = async () => {
            try {
                const response = await fetch(`https://fitnesstrac-kr.herokuapp.com/api/users/${userData.username}/routines`, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`
                    }
                })
                const result = await response.json()
                setUserRoutines(result)
                console.log(userRoutines)
                
            } catch (err) {
                console.log(err)
            }
        }
        fetchUserRoutines()
    }, [userRoutines])

    const routinesArray = Object.values(userRoutines)
    return (
        <div className="profile-container">
            {userData ? (
                <>
                    <h1>Welcome {userData.username}</h1>
                    <Link to="/Routines/Add">
                        <button className="add-activity-btn">Add a Routine</button>
                    </Link>
                    <div>My routines:</div>
                    {routinesArray ? routinesArray.map((routine) => {
                        return (
                            <div key={routine.id} className="card">
                                <h2>{routine.name}</h2>
                                <div>{routine.goal}</div>
                                <div>{routine.creatorName}</div>
                                <h5>Activies in Routine</h5>
                                {routine.activities.map((activity) => {
                                    return (
                                        <>
                                            <div>Name: {activity.name}</div>
                                            {activity.duration ? <div>Duration: {activity.duration}</div> : null}
                                            {activity.count ? <div>Count: {activity.count}</div> : null}
                                            <br></br>
                                        </>
                                    )
                                }
                                )}
                            </div>
                        );
                    }) : null}
                </>
            ) : <div>You are not signed in!</div>}
        </div>
    )
}

export default Profile